import {alcanza, AREAS_DE_ACCESO, type AreaDeAcceso, type Usuario, type UsuarioActual} from '@cnc/contracts';
import {tr} from '../i18n/idioma';
import {nivelDe} from './sesion-contexto';

// Pantalla de cada pestana con su propia direccion (decision 0062). El
// detalle de una exportacion y los paquetes documentales no tienen una propia.
export const RUTA_DE_AREA: Partial<Record<AreaDeAcceso, string>> = {
  'inventario.consolidado': '/inventario',
  'inventario.mineros': '/inventario/mineros',
  'inventario.recolecciones': '/inventario/recolecciones',
  'exportaciones.seguimiento': '/seguimiento',
  'exportaciones.reservas': '/seguimiento/reservas',
  'exportaciones.contenedores': '/seguimiento/contenedores',
  'exportaciones.gex': '/seguimiento/gex',
  'exportaciones.financiaciones': '/seguimiento/financiaciones',
  'exportaciones.navieras': '/seguimiento/navieras',
  planeador: '/planeador',
  dore: '/dore',
  cashflow: '/cashflow',
  cumplimiento: '/cumplimiento',
  'analisis.reportes': '/analisis/reportes',
  'analisis.informes': '/analisis/informes',
  'analisis.calidad': '/calidad',
  catalogos: '/configuracion-de-campos',
};

export const EXPORTACIONES: AreaDeAcceso[] = AREAS_DE_ACCESO.filter(a => a.startsWith('exportaciones.'));

export const ve = (usuario: UsuarioActual, area: string) => alcanza(nivelDe(usuario, area), 'ver');

// La primera pantalla que la persona ve de una seccion (para el menu).
export function primeraRutaDe(usuario: UsuarioActual, seccion: string): string | null {
  const area = AREAS_DE_ACCESO.find(
    a => (a === seccion || a.startsWith(`${seccion}.`)) && RUTA_DE_AREA[a] && ve(usuario, a),
  );
  return area ? RUTA_DE_AREA[area]! : null;
}

// Resumen para la tabla de usuarios: "Todo" o cuantas secciones tiene limitadas.
export function resumenDeAccesos(u: Usuario): string {
  if (u.rol === 'admin') return tr('Todo (administrador)', 'Everything (administrator)');
  const elegidos = Object.keys(u.accesos ?? {}).length;
  return elegidos
    ? tr(`Limitado (${elegidos} elegidas)`, `Limited (${elegidos} chosen)`)
    : tr('Todo lo de su rol', 'Everything of their role');
}
